import * as TabsPrimitive from '@radix-ui/react-tabs'

export const TabsContent = TabsPrimitive.Content
